import React from "react";
import { FOOTER } from "@/constants/testIds";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_phenix-patrimoine/artifacts/dsl8an5f_CA44C4B2-B46B-4B33-A16B-73FC73E4AFB6.PNG";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid={FOOTER.root}
      className="relative bg-[#0a192f] text-[#efeade]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <span className="w-11 h-11 flex items-center justify-center bg-[#000] overflow-hidden">
              <img
                src={LOGO_URL}
                alt="Phénix"
                className="w-full h-full object-contain p-1"
              />
            </span>
            <div className="leading-tight">
              <div className="font-serif text-xl">Phénix</div>
              <div className="text-[10px] tracking-[0.28em] uppercase text-[#efeade]/60">
                Patrimoine · Assurance
              </div>
            </div>
          </div>
          <p className="mt-6 max-w-sm text-[#efeade]/70 leading-relaxed text-sm">
            Cabinet de courtage indépendant en assurance et gestion de
            patrimoine, fondé à Lyon en mars 2025. Nous accompagnons
            entreprises et particuliers avec discrétion et exigence.
          </p>
        </div>

        <div className="md:col-span-3">
          <div className="overline text-[#b08d57] mb-5">Expertises</div>
          <ul className="space-y-3 text-sm text-[#efeade]/80">
            <li>Assurance vie</li>
            <li>PER / Retraite</li>
            <li>Prévoyance & Santé</li>
            <li>IRD / Entreprise</li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="overline text-[#b08d57] mb-5">Contact</div>
          <ul className="space-y-3 text-sm text-[#efeade]/80">
            <li>
              <a href="mailto:a.rechad@phenix-assurances.com" className="hover:text-[#efeade] transition-colors">
                a.rechad@phenix-assurances.com
              </a>
            </li>
            <li>
              <a href="tel:+33650347450" className="hover:text-[#efeade] transition-colors">
                +33 6 50 34 74 50
              </a>
            </li>
            <li>30 avenue Maréchal Foch, 69006 Lyon</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#efeade]/15">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-wrap items-center justify-between gap-4 text-xs text-[#efeade]/50">
          <div>© {year} Phénix Patrimoine et Assurance — Tous droits réservés.</div>
          <div className="flex items-center gap-6">
            <span>ORIAS n° 26005580</span>
            <a href="#top" className="hover:text-[#efeade] transition-colors">Mentions légales</a>
            <a href="#top" className="hover:text-[#efeade] transition-colors">Politique de confidentialité</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
